export default __webpack_public_path__ + "static/media/logo-colored.4e1664ce.png";